import { getRecoil, setRecoil } from "recoil-nexus";
import waitingRoomState, { CheckingRoomPasswordStateType } from "../../atoms/waiting-room";
import { socket } from "../index";

interface ListenReceiveChechRoomPasswordPayload {
  success: boolean;
}

const listenReceiveCheckRoomPassword = () => {
  socket?.on('RECEIVE_RESPONSE_CHECK_ROOM_PASSWORD', (payload: ListenReceiveChechRoomPasswordPayload) => {
    const waitingRoom = getRecoil(waitingRoomState);
    setRecoil(waitingRoomState, {
      ...waitingRoom,
      checkingRoomPasswordState: payload.success 
        ? CheckingRoomPasswordStateType.SUCCESS 
        : CheckingRoomPasswordStateType.FAILURE,
    })
  });
}

export default listenReceiveCheckRoomPassword;